import React from 'react';


const Modal = props => {
    const { children, isActive } = props;
    return <div className={`modal ${isActive && 'is-active'}`}>
        <div className="modal-background"></div>
        <div className="modal-content has-text-centered">
            {children}
        </div>
    </div>
}

export default Modal;



/** WEBPACK FOOTER **
 ** ./src/components/Modal.jsx
 **/